import React, { Component } from 'react';

import '../../Notes/Notes.css';
import ListOpportunitiesNotes from './ListOpportunitiesNotes';
import EditOpportunitiesNote from './EditOpportunitiesNote';
import AddOpportunitiesNote from './AddOpportunitiesNote';
import CompanyContext from '../../../auth/CompanyContext';
class OpportunitiesNotesForm extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.state = {
            opportunitiesNotes: [],
            custodians: [],
            editNoteID: 0
        };
    };

    componentDidMount = () => {
        this.getSalesOpportunitiesNotes();
    }

    getSalesOpportunitiesNotes = () => {
        // console.log('OpportunitiesNotesForm.js/getSalesOpportunitiesNotes()');
        this.props.displayCategories({ target: { value: 27 } });
        fetch('/api/salesOpportunitiesNotes/' + this.props.editOpportunity.id, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    opportunitiesNotes: results.data || [],
                    custodians: results.custodians || []
                });
            });
    }

    addNote = (date, typeID, notes, custodianIDs, cb) => {
        // console.log('OpportunitiesNotesForm.js/addNote (date, typeID, notes)', date, typeID, notes);
        fetch('/api/salesOpportunitiesNotes/', {
            method: 'POST',
            body: JSON.stringify({
                salesOpportunityID: this.props.editOpportunity.id,
                date: date,
                typeID: typeID,
                notes: notes,
                custodianIDs: custodianIDs,
                user: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (cb) cb();
                this.getSalesOpportunitiesNotes();
                this.props.getSalesOpportunities();
                // this.setState({
                //     opportunitiesNotes: results.data
                // });
            });
    }

    editNote = (id, date, typeID, notes, custodianIDs, cb) => {
        // console.log('OpportunitiesNotesForm.js/editNote (id, date, typeID, notes)', id, date, typeID, notes);
        fetch('/api/salesOpportunitiesNotes/' + id, {
            method: 'PUT',
            body: JSON.stringify({
                date: date,
                typeID: typeID,
                notes: notes,
                custodianIDs: custodianIDs,
                user: this.props.user
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (cb) cb();
                this.getSalesOpportunitiesNotes();
                this.props.getSalesOpportunities();
                this.setState({
                    editNoteID: 0
                });
            });
    }

    deleteNote = (id, cb) => {
        // console.log('OpportunitiesNotesForm.js/deleteNote (id)', id);
        fetch('/api/salesOpportunitiesNotes/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (cb) cb();
                this.getSalesOpportunitiesNotes();
                this.props.getSalesOpportunities();
                this.setState({
                    editNoteID: 0
                });
            });
    }

    isFormBlank(array) {
        let retBool = true;
        array.forEach(row => {
            if (row.value !== null && row.value !== '') { retBool = false; }
        })
        return retBool;
    }

    handleEditSwap = (id) => {
        this.setState({ editNoteID: id })
    }

    render() {
        return (<>
            <AddOpportunitiesNote {...this.props}
                addNote={this.addNote}
                handleCancel={this.props.handleCancel}
                displayCategories={this.props.displayCategories}
                addCategoryCommentsArray={this.props.addCategoryCommentsArray}
                editCategoryCommentsArray={this.props.editCategoryCommentsArray}
                custodians={this.state.custodians}
                isFormBlank={this.isFormBlank}
            />
            {this.state.opportunitiesNotes.map((row, rowIndex) => (
                <div key={row.id} className='mb-2'>
                    <hr className='border-dark' />
                    {this.state.editNoteID !== row.id ? (
                        <ListOpportunitiesNotes {...this.props} row={row}
                            handleEditSwap={this.handleEditSwap}
                        />
                    ) : (
                        <EditOpportunitiesNote {...this.props}
                            row={row}
                            custodians={this.state.custodians}
                            handleEditSwap={this.handleEditSwap}
                            editNote={this.editNote}
                            deleteNote={this.deleteNote}
                            isFormBlank={this.isFormBlank}
                        />
                    )
                    }
                </div>
            ))}
        </>
        );

    }

}

export default OpportunitiesNotesForm;
